<template>
  <section class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRefresh" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRefresh" :key="$route.fullPath"></router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data () {
    return {
      isRefresh: true
    }
  },
  computed: {
    key () {
      return this.$route.fullPath
    }
  },
  activated () {
  },
  methods: {
    refresh () {
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  flex: 1;
  height: 100%;
  width: 100%;
  // min-height: 0;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AppMain.vue